import React, { useEffect, useRef } from 'react'

import request from '@function/ajax/request'

export default function Fetcher ({ onSuccess, onError, ...props })
{
	const _refs = useRef();

	useEffect(function ()
	{
		_refs.current = { };

		_refs.current.onError = onError;
		_refs.current.onSuccess = onSuccess;
	},
	[onSuccess, onError]);

	useEffect(function ()
	{
		const controller = new AbortController();

		(async function ()
		{
			try
			{
				var response = await request(props.url)
				.config({ controller, keyword: 'ressource' })
				.post(props.data || { });
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				return _refs.current?.onError?.(update);
			}

			_refs.current?.onSuccess?.(response || { });
		})();

		return () => { controller.abort?.(); };
	},
	[props.url, props.data]);

	return null;
}